import { createLogic } from "redux-logic";
import * as DOMUtils from "history/DOMUtils";
import { updateFinanceQueryParam } from "../../../../../common-deprecated/History";
import type { SetFinanceOptionType } from "../../../../../common-deprecated/redux/actions/UtilActions";
import { SET_FINANCE_OPTION } from "../../../../../common-deprecated/redux/actions/UtilActions";
import type { CarConfigLogicType } from "../store";
import { showTradeInNotification } from "../../utils/typedUtils";
import { startConfigSave } from "../slices/CarConfigSaveSlice";
import { setTradeInAemIncompatible } from "../../../../../common-deprecated/features/tradein/redux/actions/TradeInAemExternalDataActions";
import { checkAndSetFinanceProductTradeInCompatibility } from "../../utils/basketUtils";

const setFinanceOption = (createLogic as CarConfigLogicType<SetFinanceOptionType>)({
    type: SET_FINANCE_OPTION,

    validate({ getState, action }, allow, reject) {
        const isMonthly = action.option === "monthly";

        if (isMonthly) {
            const hasFinanceQuote = !!getState().finance.quotes.finance;
            const { requireFinanceQuoteToDisplayFinanceData } = getState().carConfigSettings;

            if (requireFinanceQuoteToDisplayFinanceData && !hasFinanceQuote) {
                return (reject as () => void)();
            }
        }

        return allow(action);
    },

    process({ getState, action }, dispatch, done) {
        const { tradeInAemExternalData, finance, carConfigSettings } = getState();
        if (DOMUtils.canUseDOM) {
            updateFinanceQueryParam(action.option);
        }

        if (tradeInAemExternalData.data) {
            const isMonthly = action.option === "monthly";

            if (!isMonthly && tradeInAemExternalData.incompatible) dispatch(setTradeInAemIncompatible(false));
            else if (isMonthly)
                checkAndSetFinanceProductTradeInCompatibility(
                    tradeInAemExternalData.data,
                    !!tradeInAemExternalData.incompatible,
                    "monthly",
                    finance.info.productName,
                    carConfigSettings,
                    dispatch,
                );
        }
        // restart the toyota config as the financeOption should be passed along to the tyCode.
        dispatch(startConfigSave());

        // Integrated trade-in: Check if a notification is still pending when switching between cash/monthly
        // This will show a notification if the notification wasn't shown in the past
        showTradeInNotification(getState(), dispatch);

        done();
    },
});

export default [setFinanceOption];
